import { FC } from 'react'
import { get, noop } from 'lodash-es'
import Image from './Image'
import { Photo } from '@app-types/entity_types'

type PhotoPreviewProps = {
  photo?: Photo | null
  thumbnailStyle?: string
  onClick?: (id: string | null) => void
}

const PhotoPreview: FC<PhotoPreviewProps> = ({ photo = null, thumbnailStyle = 'small_landscape', onClick = noop }) => {
  const handleImageClick = () => {
    if (photo) {
      onClick(photo.id)
    } else {
      onClick(null)
    }
  }

  const getImageProps = () => {
    if (photo) {
      return (
        get(photo, ['image_urls', thumbnailStyle]) || get(photo, ['attributes', 'image_urls', thumbnailStyle]) || null
      )
    }
    return null
  }

  const imageProps = getImageProps()
  if (imageProps) {
    const src = get(imageProps, 'src')
    if (src) {
      return (
        <Image
          src={src}
          width={imageProps.width}
          height={imageProps.height}
          onClick={handleImageClick}
          testId="qa-photo-preview"
        />
      )
    }
  }
  return null
}

export default PhotoPreview
